const buyRefurbishedCustomBanners = [{
  "isVisible": true,
  "title": "Revamp your space affordably with refurbished furniture.",
  titleImageUrl: {
    hovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-buy-refurbished-unhovered.png',
    unhovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-buy-refurbished-unhovered.png'
  },
  "subTitle": {
    content: "Know more",
    color: "Minty 0",
  },
  unhoveredStyles: {
    cardBgColor: "Minty -4",
    borderColor: "Minty -3",
  },
  hoveredStyles: {
    cardBgColor: "",
    borderColor: "Minty -2",
  },
  "cta": {
    "action": "click",
    "data": {
      "actionData": {
        "deeplinkPath": "/layout?type=PDP_BUY_REF_INFO"
      },
      "type": "Navigation"
    }
  }
}];

const buyNewCustomBanners = [{
  "isVisible": true,
  "title": "Revamp your space in style with brand new furniture.",
  titleImageUrl: {
    hovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-buy-new-unhovered.png',
    unhovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-buy-new-unhovered.pngg'
  },
  "subTitle": {
    content: "Know more",
    color: "Navy 0",
  },
  unhoveredStyles: {
    cardBgColor: "Navy -3",
    borderColor: "Navy -3",
  },
  hoveredStyles: {
    cardBgColor: "",
    borderColor: "Navy -2",
  },
  "cta": {
    "action": "click",
    "data": {
      "actionData": {
        "deeplinkPath": "/layout?type=PDP_BUY_NEW_INFO"
      },
      "type": "Navigation"
    }
  }
}];

const rentCustomBanners = [{
  "isVisible": true,
  "title": "Revamp your space in style with brand new furniture.",
  titleImageUrl: {
    hovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-rent-hovered.png',
    unhovered: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/pdp-custom-banner-rent-unhovered.png'
  },
  "subTitle": {
    content: "Know more",
    color: "Orange 0",
  },
  unhoveredStyles: {
    cardBgColor: "Orange -3",
    borderColor: "Orange -3",
  },
  hoveredStyles: {
    cardBgColor: "",
    borderColor: "Orange -1",
  },
  "cta": {
    "action": "click",
    "data": {
      "actionData": {
        "deeplinkPath": "/layout?type=PDP_RENT_INFO"
      },
      "type": "Navigation"
    }
  }
}];

export const ConfigurationsByLop = new Map([
  [
    'BUY_REFURBISHED',
    {
      trustMarkers: {
        imageUrl: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/desktop/trust_marker_buy_refurbished.jpg',
      },
      customBanners: buyRefurbishedCustomBanners
    }
  ],
  [
    'BUY_NEW',
    {
      trustMarkers: {
        imageUrl: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/desktop/trust_marker_buy_new.jpg',
      },
      customBanners: buyNewCustomBanners
    },
  ],
  // [
  //   'RENT',
  //   {
  //     trustMarkers: {
  //       imageUrl: 'https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/desktop/trust_marker_rent.jpg',
  //     },
  //     customBanners: rentCustomBanners
  //   },
  // ],
]);